import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypesSupportingCustomSourceObject } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import Organization from "@mapmycustomers/shared/types/Organization";

import CommonFieldName from "@app/util/fieldModel/CommonFieldName";
import { isSourceObjectField } from "@app/util/fieldModel/impl/assert";
import loggingService from "@app/util/logging";
import { hasCustomSourceObjects } from "@app/util/ui";

export const sourceObjectFieldFilter = (field: IField): boolean =>
  !field.hasFeature(FieldFeature.SOURCE_OBJECT_FIELD);

// Idempotent: onInitialize runs again on re-login without a reload, and the models are singletons
const setupSourceObjectField = (
  fieldModel: Pick<IFieldModel, "addFieldFilter" | "allFields" | "removeFieldFilter">,
  entityType: EntityTypesSupportingCustomSourceObject,
  sourceObjects: Organization["sourceObjects"]
) => {
  // allFields bypasses the filters, so a hide filter from a previous login cannot hide it here
  const field = fieldModel.allFields.find((item) => item.name === CommonFieldName.SOURCE_OBJECT);
  if (!field || !isSourceObjectField(field)) {
    loggingService.error(`${entityType} field model has no SourceObjectField`);
    return;
  }
  const values = sourceObjects?.[entityType]?.values ?? [];
  fieldModel.removeFieldFilter(sourceObjectFieldFilter);
  field.setSourceObjects(values);
  if (!hasCustomSourceObjects(values)) {
    fieldModel.addFieldFilter(sourceObjectFieldFilter);
  }
};

export default setupSourceObjectField;
